module.exports = __webpack_public_path__ + "img/Hongkong-3-hover.904b9ff6.jpg";